import RadioGroup from '@mui/material/RadioGroup'

import { RadioListItem } from '../../list-item/radio-list-item'
import { radioListSeparatorSx } from '../listClasses'
import type { SelectableListItem } from '../types'

export interface RadioListProps<T> {
  data: SelectableListItem<T>[]
  onClick: (id: T) => void
  defaultSublabel?: string
  variant?: 'outlined' | 'small'
  hasSeparators?: boolean
  direction?: 'row' | 'column'
  'aria-labelledby'?: string
}

export const RadioList = <T,>({
  data,
  defaultSublabel,
  onClick,
  variant,
  hasSeparators,
  direction = 'column',
  'aria-labelledby': ariaLabelledBy,
}: RadioListProps<T>) => {
  return (
    <RadioGroup
      aria-labelledby={ariaLabelledBy}
      sx={{
        ...(variant === 'outlined'
          ? {
              display: 'flex',
              flexDirection: direction,
              gap: 1,
            }
          : {}),
        ...(hasSeparators ? radioListSeparatorSx : {}),
      }}
    >
      {data.map((item, index) => (
        <RadioListItem
          {...item}
          onClick={onClick}
          key={index}
          variant={variant}
          additionalText={item.additionalText || defaultSublabel}
        />
      ))}
    </RadioGroup>
  )
}
